import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_profile_picture = _resolveComponent("user-profile-picture")!
  const _component_comment_card = _resolveComponent("comment-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_user_profile_picture, {
      userEmail: _ctx.reply.userid,
      cssClass: "user-icon"
    }, null, 8, ["userEmail"]),
    _createElementVNode("div", {
      class: "comment-form d-flex flex-column",
      id: _ctx.reply.id
    }, [
      _createVNode(_component_comment_card, {
        comment: _ctx.reply,
        forceShowDeleteCommentButtons: _ctx.forceShowDeleteCommentButtons,
        onCommentDeleted: _ctx.emitCommentDeleted
      }, null, 8, ["comment", "forceShowDeleteCommentButtons", "onCommentDeleted"])
    ], 8, _hoisted_1)
  ], 64))
}